import type {
  RoomOffsetHierarchy,
  RoomOffsetHierarchySettings,
} from 'lumen/models/recommendation-strategy';
import {
  OVERRIDE_TYPES,
  type OverrideTypes,
  type OverrideVariant,
} from 'lumen/utils/constants/pricing-assistant-constants';

// Breadth-first traversal to flatten the hierarchy (traverses siblings before children)
export function getFlattenedHierarchy(
  hierarchy: RoomOffsetHierarchySettings['hierarchy'],
): string[] {
  const flattened: string[] = [];
  const queue: { name: string; node: RoomOffsetHierarchy }[] = [];

  // Enqueue all root nodes
  for (const rootName of Object.keys(hierarchy)) {
    const node = hierarchy[rootName];
    if (node) {
      queue.push({ node, name: rootName });
    }
  }

  // Process the queue
  while (queue.length > 0) {
    const { node, name } = queue.shift()!;
    flattened.push(name);
    // Enqueue all children
    for (const roomName of Object.keys(node.children || {})) {
      const childNode = node.children[roomName];
      if (childNode) {
        queue.push({ node: childNode, name: roomName });
      }
    }
  }

  return flattened;
}

export function getOverrideVariant(
  overrideType: OverrideTypes | null | undefined,
): OverrideVariant | undefined {
  if (!overrideType) {
    return undefined;
  }
  return overrideType === OVERRIDE_TYPES.PRICE_RANGE
    ? 'bullet'
    : 'automation-off';
}

/* Calculate the total rooms for sale by adding the physical rooms available and the current overbooking. */
export function calculateTotalRoomsForSale(
  physicalRoomsAvailable: number,
  currentOverbooking: number,
): number {
  return physicalRoomsAvailable + currentOverbooking;
}
